import React from "react";
import * as PropTypes from "prop-types";

import {
  canApproveResponses, canDraftResponses,
  canReply,
  cantReplyThroughDashboard,
  isPublishingFeature
} from "./ToolbarActions";
import {PostReplyEditor} from "../components/index";
import {PublishingTeaserTooltip} from "../PublishingTeaser";
import {PublishedResponse} from "./PublishedResponse";
import {publish} from "../api";
import {ToastService} from "../../../../components/toasts/Toasts";
import SlideOpen from "../../animations/SlideOpen";
import {TransitionGroup} from "react-transition-group";
import {observer} from "mobx-react";

@observer
export default class PostResponder extends React.Component {


  static propTypes = {
    item: PropTypes.any.isRequired,

    onResponseSaved: PropTypes.any,
    isEditing: PropTypes.bool,

    placeholder: PropTypes.string,
    hideNotes: PropTypes.bool,

    filterOutSuccessful: PropTypes.bool,
    hidePostsBeingPublished: PropTypes.bool

  };


  static defaultProps = {
    placeholder: "Type your reply",
    isEditing: false,
    hideNotes: false,
    filterOutSuccessful: false,
    hidePostsBeingPublished: false
  };


  constructor(props) {
    super(props);

    this.state = {
      isEditing: props.isEditing
    };
  }

  onPostSaved = (post) => {
    const { onResponseSaved } = this.props;
    if (post) {
      const message = canApproveResponses() ? 'Reply submitted for publishing' : 'Your reply has been submitted for review';
      const failureMessage = canApproveResponses() ? 'Failed to submit for publishing' : 'Failed to submit for review';
      publish(post).then( (posted) => {
        ToastService.success("Reply created", message);
        onResponseSaved && onResponseSaved(posted);
        this.setState({isEditing: false})
      }).catch((e) => {
        if (e.message) {
          ToastService.error("Failed to submit", e.message);
        } else {
          ToastService.error("Failed to submit", failureMessage);
        }
      });
    } else {
      this.setState({isEditing: false})
    }
  };


  render() {
    const {item,  placeholder, hideNotes, filterOutSuccessful, hidePostsBeingPublished} = this.props;
    const post = {
      ...item,
      scheduledResponses: item.scheduledResponses
    };
    const {isEditing} = this.state;

    let placeholderText = placeholder || "Type your reply";
    const publishedResponses = post.scheduledResponses
      .filter(x => (x.publishType === 'Reply' || x.publishType === 'Repost'));


    let publishingElement;
    const cantBeRespondedTo = cantReplyThroughDashboard({item: post});
    const hasAbilityToRespond = canReply({item: post}) && isPublishingFeature() && !!(canDraftResponses());

    if (!canDraftResponses()) {
      publishingElement = null
    } else if (hasAbilityToRespond && isEditing) {
      publishingElement = <PostReplyEditor
        onComplete={this.onPostSaved}
        post={post}
        modalMode
        inResponseTo={item}
        placeholder={placeholderText}
      />
    } else {
      publishingElement = <PublishingTeaserTooltip
        hasPublishing={hasAbilityToRespond}
        cantBeRespondedTo={cantBeRespondedTo}
        children={
          <div key="notEditing"
               className={`chatter-publish-textarea-container compact`}
               onClick={() => {
                 // This is to prevent the component from updating as there is a bug in PublishingTeaserTooltip
                 hasAbilityToRespond && this.setState({isEditing: true})
               }}>
                <textarea disabled={!hasAbilityToRespond} placeholder={placeholderText}
                          className="chatter-publish-textarea form-control"
                          rows="1"/>
          </div>
        } />
    }

    let publishedResponseElement;

    if (!hidePostsBeingPublished && publishedResponses.length) {
      publishedResponseElement = <div style={{marginTop: '0.5rem'}}>
        <h6>Publishing</h6>
        <TransitionGroup>
          {
            publishedResponses.filter((x) => {
              if (!filterOutSuccessful) return true;
              else {
                return !x.completeTime;
              }
            }).map(item => {
              let key = !!item._id.$oid ? item._id.$oid : item._id;
              return <SlideOpen key={key}>
                <PublishedResponse key={key} hideNotes={hideNotes} item={item}/>
              </SlideOpen>
            })
          }
        </TransitionGroup>
      </div>
    }

    return (
      <div>
        {publishingElement}
        {publishedResponseElement}
      </div>
    );
  }
}
